<template>
    <div class="e6-breadcrumb">
        <el-breadcrumb :separator="separator">
            <el-breadcrumb-item v-for="(breadcrumb, index) in breadcrumbs" :key="index">
                <router-link v-if="breadcrumb.isRedirect" :to="breadcrumb.path">{{breadcrumb.meta.title}}</router-link>
                <template v-else>{{breadcrumb.meta.title}}</template>
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>

<script>
    export default {
        name: "E6Breadcrumb",
        props: {
            separator: {
                type: String,
                default: "/"
            },
            breadcrumbs: {
                type: Array
            }
        }
    };
</script>
